// extracted by mini-css-extract-plugin
export var tosLink = "_bl-0";